export function validateTransferInput({
  toUserEmail, // 🎯 Nowy: email zamiast walletId
  amount,
  fromWalletId,
  balance,
  fromUserId,
}) {
  const missingFields = [];

  if (!toUserEmail?.trim()) missingFields.push("To user email");
  if (!amount) missingFields.push("Amount");

  if (missingFields.length > 0) {
    return `Please fill in: ${missingFields.join(", ")}.`;
  }

  if (Number(amount) <= 0) {
    return "Amount must be greater than zero.";
  }

  if (balance === 0 || balance < Number(amount)) {
    return "Insufficient balance for this transfer.";
  }

  if (toUserEmail.trim().toLowerCase() === fromUserId?.toLowerCase()) {
    return "You cannot transfer funds to yourself.";
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(toUserEmail)) {
    return "Please enter a valid email address.";
  }

  return null;
}

export function parseTransferError(error) {
  const status = error?.status || error?.response?.status;
  const detail = error?.message || error?.response?.data?.detail || error?.response?.data?.error || "Transfer failed.";

  if (typeof detail === "string") {
    if (detail.toLowerCase().includes("insufficient")) {
      return "Insufficient balance for this transfer.";
    }
    if (detail.toLowerCase().includes("invalid user") || detail.toLowerCase().includes("not found")) {
      return "Recipient user not found or invalid email.";
    }
    if (detail.toLowerCase().includes("same user") || detail.toLowerCase().includes("self")) {
      return "You cannot transfer funds to yourself.";
    }
  }

  switch (status) {
    case 400:
      return "Invalid wallet ID or amount. Please check your input.";
    case 401:
      return "Your session has expired. Please sign in again.";
    case 403:
      return "You are not authorized to perform this transfer.";
    case 404:
      return "Wallet not found. Please check the wallet ID.";
    case 422:
      return "Data validation failed. Please check wallet ID and amount.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service is temporarily unavailable. Please try again in a moment.";
    default:
      return "Transfer failed. Please try again or contact support.";
  }
}
